import styled from "styled-components";
import ThemedParagraph from "./ThemedParagraph";

const FiltersAppliedWarningMessage = styled(ThemedParagraph)`
    font-size: 12px !important;
`;

export default FiltersAppliedWarningMessage;